import { promoClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { Promo } from "@core/types";

interface UseGetPromoByIdInfiniteQueryProps {
  id: string;
  options?: UseQueryOptions<Promo | null>;
}

const useGetPromoByIdQuery = ({ id, options }: UseGetPromoByIdInfiniteQueryProps) => {
  return useQuery<Promo | null, any>(
    ["promos/id", id],
    async () => {
      const data = await promoClient.getPromoById(id);
      return data;
    },
    {
      ...options,
    }
  );
};

export default useGetPromoByIdQuery;
